import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";

var _class, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "e64b3KrClhLZZi/ochZKo1f", "GameDistribution", undefined);

//@ts-nocheck
import { resources, _decorator } from "cc";
import { E_ADEventType } from "../../EnumBase";
import AdEvent from "../AdEvent";
var ccclass = _decorator.ccclass;

var GameDistribution = ccclass(_class = (_temp = /*#__PURE__*/function () {
  function GameDistribution() {
    _defineProperty(this, "bannerLoaded", false);

    _defineProperty(this, "interstitialAdLoaded", false);

    _defineProperty(this, "videoAdLoaded", false);

    _defineProperty(this, "_isCallPlay", false);

    _defineProperty(this, "isBannering", false);
  }

  var _proto = GameDistribution.prototype;

  _proto.init = function init() {// let that = this;
    // window["GD_OPTIONS"] = {
    //     "gameId": "9b115cdb46984afbbd0648bc159d4137",
    //     "onEvent": function(event) {
    //         switch (event.name) {
    //             case "SDK_READY":
    //                 console.log("SDK_READY");
    //                 // window["gdsdk"].openConsole();
    //                 that.createInterstitialAd();
    //                 that.createRewardedVideoAd();
    //                 break;
    //             case "SDK_ERROR":
    //                 console.log("SDK_ERROR");
    //                 break;
    //             case "SDK_GAME_START":
    //                 console.log("SDK_GAME_START");
    //                 SoundManager.I.resumeSoundAndMusicByAd();
    //                 that._isCallPlay = false;
    //                 // advertisement done, resume game logic and unmute audio
    //                 break;
    //             case "SDK_GAME_PAUSE":
    //                 console.log("SDK_GAME_PAUSE");
    //                 SoundManager.I.pauseSoundAndMusicByAd();
    //                 // pause game logic / mute audio
    //                 break;
    //             case "SDK_GDPR_TRACKING":
    //                 console.log("SDK_GDPR_TRACKING");
    //                 // this event is triggered when your user doesn't want to be tracked
    //                 break;
    //             case "SDK_GDPR_TARGETING":
    //                 console.log("SDK_GDPR_TARGETING");
    //                 // this event is triggered when your user doesn't want personalised targeting of ads and such
    //                 break;
    //         }
    //     },
    // };
    // (function(d, s, id) {
    //     var js, fjs = d.getElementsByTagName(s)[0];
    //     if (d.getElementById(id)) return;
    //     js = d.createElement(s);
    //     js.id = id;
    //     js.src = 'https://html5.api.gamedistribution.com/main.min.js';
    //     fjs.parentNode.insertBefore(js, fjs);
    // }(document, 'script', 'gamedistribution-jssdk'));
  };

  _proto.playAD = function playAD() {
    if (this._isCallPlay) return;
    this._isCallPlay = true;

    if (typeof window["gdsdk"] !== 'undefined' && window["gdsdk"].showAd !== 'undefined') {
      window["gdsdk"].showAd();
    }
  } // 创建Banner广告 创建一次即可，自动刷新广告
  // 参数
  //   adId: string 广告序号ID 游戏自定义
  //   bannerAdId: string Banner广告ID 需后台申请
  //   position: int 广告位置 1 屏幕顶部 2 屏幕底部
  ;

  _proto.createBannerAd = function createBannerAd() {};

  _proto.showBannerAd = function showBannerAd() {};

  _proto.hideBannerAd = function hideBannerAd() {} // 创建插屏广告 展示一次调用一次创建
  // 参数
  //   adId: string 广告序号ID 游戏自定义
  //   interstitialAdId: string 插屏广告ID 需后台申请
  //   style: int 广告类型 1 全屏 2 半屏
  ;

  _proto.createInterstitialAd = function createInterstitialAd() {
    var gameBody = null;
    gameBody = document.body; // if (window.location.href.indexOf("local") == -1) {
    //     gameBody = document.body;
    // } else {
    //     gameBody = document.getElementById("GameDiv");
    // }

    if (gameBody) {
      var adDiv = document.createElement("div");
      adDiv.id = "gameAdDivSelf";
      adDiv.style.width = 300 + "px";
      adDiv.style.height = 250 + "px";
      adDiv.style.margin = "-150px 0 0 -125px";
      adDiv.style.position = "absolute";
      adDiv.style.left = "50%";
      adDiv.style.top = "50%";
      adDiv.style.display = "none";
      gameBody.appendChild(adDiv);
      var btn = document.createElement("button");
      btn.type = "button";
      adDiv.appendChild(btn);
      btn.style.position = "absolute";
      btn.style.left = "-32px";
      btn.style.top = "-32px";
      btn.style.border = "0px solid transparent";
      btn.style.outline = "none";
      btn.style.background = "no repeat";
      btn.style.backgroundColor = "transparent";

      btn.onclick = function () {
        adDiv.style.display = "none";
      };

      var img = document.createElement("img");
      btn.appendChild(img);
      resources.load("closeBtn", function (err, sf) {
        img.src = sf.nativeUrl;
      });
      console.log("createInterstitialAd true");
      this.interstitialAdLoaded = true;
    } else {
      console.log("createInterstitialAd false");
    }
  };

  _proto.showInterstitialAd = function showInterstitialAd() {
    if (!document.getElementById("gameAdDivSelf")) {
      this.createInterstitialAd();
    }

    if (document.getElementById("gameAdDivSelf")) {
      var adDiv = document.getElementById("gameAdDivSelf");

      if (adDiv) {
        window["gdsdk"].showAd(window["gdsdk"].AdType.Display, {
          containerId: "gameAdDivSelf"
        }).then(function () {
          adDiv.style.display = "";
          console.info('showAd(window.gdsdk.AdType.Display) resolved.');
        })["catch"](function (error) {
          adDiv.style.display = "none";
          console.info(error);
        });
      }
    } else {
      console.log("this._interstitialAd 广告未加载成功");
    }
  } // 创建激励视频广告 展示一次创建一次
  // 参数
  //   adId: string 广告序号ID 游戏自定义
  //   videoAdId: string 视频广告ID 需后台申请
  //   screenOrientation: int 广告类型 1 横屏 2 竖屏
  ;

  _proto.createRewardedVideoAd = function createRewardedVideoAd() {
    if (window["gdsdk"] !== "undefined") {
      var that = this;
      window["gdsdk"].preloadAd('rewarded').then(function (response) {
        that.videoAdLoaded = true;
        console.log("createRewardedVideoAd 视频加载成功"); // A rewarded ad can be shown to user when he/she clicked it.
      })["catch"](function (error) {
        that.videoAdLoaded = false;
        console.log("createRewardedVideoAd 视频加载失败"); // Any Rewarded ad is not available to user.
      });
    } else {
      console.error("gdsdk is not exit");
    }
  };

  _proto.showRewardedVideoAd = function showRewardedVideoAd() {
    if (this.videoAdLoaded) {
      if (window["gdsdk"] !== 'undefined' && window["gdsdk"].showAd !== 'undefined') {
        var that = this;
        window["gdsdk"].showAd('rewarded').then(function (response) {
          // Reward the player here.
          AdEvent.I.handleEvent(E_ADEventType.video_showOver);
          setTimeout(function () {
            that.createRewardedVideoAd();
          }, 1000);
        })["catch"](function (error) {
          // EventManager.I.handleEvent(E_EventType.Tip_Show, I18nManager.Instance.t("ad.noAd"));
          AdEvent.I.handleEvent(E_ADEventType.video_showFail); // An error catched. Please don't give reward here.
        });
        console.log("rewardedvideoAd 视频广展示");
      } else {
        this.createRewardedVideoAd(); // EventManager.I.handleEvent(E_EventType.Tip_Show, I18nManager.Instance.t("ad.noAd"));

        console.error("rewardedvideoAd 视频广告未加载成功");
      }
    }
  }
  /**loading 差评 */
  ;

  _proto.showPreRoll = function showPreRoll() {
    if (typeof window["gdsdk"] !== 'undefined' && window["gdsdk"].showAd !== 'undefined') {
      window["gdsdk"].showAd();
    }
  };

  return GameDistribution;
}(), _temp)) || _class;

export { GameDistribution as default };

_cclegacy._RF.pop();